import { Dashboards, InboxView, ChartsView, SearchView, TaskView, ElementsView, ComponentsView, CardsView, FormsView, TablesView, Timeline, TimelineGallery, Typography, Illustrations, Pricing, Faq, Icons, Error500, NotFound } from './views';

var routes = [
    { path: "/", name: "Home", component: Dashboards['Dashboard'], showInNav: false },
    { path: "/home", name: "Dashboard 1", component: Dashboards['Dashboard'], showInNav: false },
    { path: "/home1", name: "Dashboard 2", component: Dashboards['Dashboard1'], showInNav: false },
    { path: "/home2", name: "Dashboard 3", component: Dashboards['Dashboard2'], showInNav: false },
    { path: "/home3", name: "Dashboard 4", component: Dashboards['Dashboard3'], showInNav: false },
    { path: "/home4", name: "Dashboard 5", component: Dashboards['Dashboard4'], showInNav: false },
    { path: "/layout1", name: "Layout 1", component: Dashboards['Dashboard1'], showInNav: false, layout: 'Layout1' },
    { path: "/layout2", name: "Layout 2", component: Dashboards['Dashboard3'], showInNav: false, layout: 'Layout2' },
    { path: "/", name: "Dashboards", showInNav: true, icon:"icon-speedometer icons align-middle mr-1", 
        children:[
            {name:"Dashboard 1", path:"/home", component: Dashboards['Dashboard']},
            {name:"Dashboard 2", path:"/home1", component: Dashboards['Dashboard1']},
            {name:"Dashboard 3", path:"/home2", component: Dashboards['Dashboard2']},
            {name:"Dashboard 4", path:"/home3", component: Dashboards['Dashboard3']},
            {name:"Dashboard 5", path:"/home4", component: Dashboards['Dashboard4']}
        ]
    },
    { path: "/charts", name: "Charts", component: ChartsView, showInNav: true, icon:"icon-chart icons align-middle mr-1" },
    { path: "/inbox", name: "Inbox", component: InboxView, showInNav: true, icon:"icon-drawer icons align-middle mr-1" },
    { path: "/tasks", name: "Kanban", component: TaskView, showInNav: true, icon:"icon-notebook icons align-middle mr-1" },
    { path: "/search", name: "Search", component: SearchView, showInNav: true, icon:"icon-magnifier icons align-middle mr-1" },
    { path: "/forms", name: "Forms", component: FormsView, showInNav: true, icon:"icon-note icons align-middle mr-1" },
    { path: "/tables", name: "Tables", component: TablesView, showInNav: true, icon:"icon-grid icons align-middle mr-1" },
    { path: "/components", name: "Components", component: ComponentsView, showInNav: true, icon:"icon-target icons align-middle mr-1" },
    { path: "/", name: "UI Kit", component: ElementsView, showInNav: true, icon:"icon-layers icons align-middle mr-1",
        children:[
            {name:"Cards & Widgets", path:"/cards", component: CardsView},
            {name:"Elements", path:"/elements", component: ElementsView},
            {name:"Typography", path:"/typography", component: Typography},
            {name:"Icons", path:"/icons", component: Icons}
        ]
    },
    { path: "/cards", name: "Cards", component: CardsView, showInNav: false, icon:"icon-doc icons align-middle mr-1" },
    { path: "/icons", name: "Icons", component: Icons, showInNav: false, icon:"icon-puzzle icons mr-1" },
    { path: "/typography", name: "Typography", component: Typography, showInNav: false, icon:"icon-eyeglass icons align-middle mr-1" },
    { path: "/timeline", name: "Timeline", component: Timeline, showInNav: false },
    { path: "/elements", name: "ElementsView", component: ElementsView, showInNav: false },
    { path: "/gallery", name: "Timeline Gallery", component: TimelineGallery, showInNav: false },
    { path: "/pricing", name: "Pricing", component: Pricing, showInNav: false },
    { path: "/vectors", name: "Artwork", component: Illustrations, showInNav: false },
    { path: "/faq", name: "FAQ", component: Faq, showInNav: false },
    { path: "/notfound", name: "Error 404", component: NotFound, showInNav: false },
    { path: "/500", name: "Error 500", component: Error500, showInNav: false },
    { path: "/", name: "Pages", showInNav: true, icon:"icon-docs icons align-middle mr-1", 
        children:[
            {name:"Timeline", path:"/timeline", component: Timeline},
            {name:"Gallery", path:"/gallery", component: TimelineGallery},
            {name:"Artwork", path:"/vectors", component: Illustrations},
            {name:"Pricing", path:"/pricing", component: Pricing},
            {name:"FAQ", path:"/faq", component: Faq},
            {name:"Error 404", path:"/notfound", component: NotFound},
            {name:"Error 500", path:"/500", component: Error500}
        ]
    },
    { path: "/", name: "Layouts", showInNav: true, icon:"icon-grid icons align-middle mr-1", 
        children:[
            {name:"Sidebar", path:"/layout1", component: Dashboards['Dashboard1'], layout: 'Layout1'},
            {name:"Top Navbar", path:"/layout2", component: Dashboards['Dashboard1'], layout: 'Layout2'}
        ]
    },
    { path: "/*", name: "NotFound", component: NotFound}
];

export {
    routes
};
